import { createSlice } from "@reduxjs/toolkit";

const snackbarSlice = createSlice({
  name: "snackbar",
  initialState: {
    open: false,
    message: "",
    severity: "success", // 'success', 'error', 'info', 'warning'
    messages: [],
    input: "",
    formControlDisabled: false,
    product: "",
    keyMessages: "",
    emailData: "",
    minRows: 0,
    maxRows: 10,
    filtered: [],
    newChatClicked: false,
    activeSessionId: null,
    activeChatToolId: null,
  },
  reducers: {
    showSnackbar: (state, action) => {
      state.open = true;
      state.message = action.payload.message;
      state.severity = action.payload.severity;
    },
    hideSnackbar: (state) => {
      state.open = false;
      state.message = "";
    },
    messageUpdate: (state, action) => {
      if (Array.isArray(action.payload)) {
        state.messages.push(...action.payload);
      } else {
        // state.messages.push(action.payload);
        console.error("Expected array but received:", action.payload);
      }
    },
    resetMessages: (state, action) => {
      state.messages = [];
    },
    inputUpdate: (state, action) => {
      state.input = action.payload;
    },
    disableFormContol: (state, action) => {
      state.formControlDisabled = action.payload;
    },
    productsUpdate: (state, action) => {
      state.product = action.payload;
    },
    keyMessageUpdate: (state, action) => {
      state.keyMessages = action.payload;
    },
    emailDataUpdate: (state, action) => {
      state.emailData = action.payload;
    },
    incrementNoOfDays: (state, action) => {
      // minRows = API offset; maxRows = fixed page size (do not increment)
      state.minRows = state.minRows + state.maxRows;
    },
    initializeNoOfDays: (state, action) => {
      state.minRows = 0;
      state.maxRows = 10;
    },
    filteredStateUpdate: (state, action) => {
      state.filtered = action.payload;
    },
    newChatStateUpdate: (state, action) => {
      state.newChatClicked = action.payload;
      if (action.payload) {
        state.activeChatToolId = null;
      }
    },
    setActiveSessionId: (state, action) => {
      state.activeSessionId = action.payload; // session_id string
    },
    clearActiveSessionId: (state) => {
      state.activeSessionId = null;
    },
    setActiveChatToolId: (state, action) => {
      state.activeChatToolId = action.payload || null;
    },
  },
});

export const {
  showSnackbar,
  hideSnackbar,
  messageUpdate,
  resetMessages,
  inputUpdate,
  disableFormContol,
  productsUpdate,
  keyMessageUpdate,
  emailDataUpdate,
  incrementNoOfDays,
  initializeNoOfDays,
  filteredStateUpdate,
  newChatStateUpdate,
  setActiveSessionId,
  clearActiveSessionId,
  setActiveChatToolId,
} = snackbarSlice.actions;

export default snackbarSlice.reducer;
